<script>
import _ from 'lodash'
import { captionsExceptBy } from '../../Presentaciones/archetype'
import { archetype, automodalHandler } from './archetype'
import PresentacionQuicktable from '../../Presentaciones/quicktable.vue'

export default {
    name: 'conceptArticulosAutomodal',
    components: { PresentacionQuicktable },
    props: {
        conceptId: {
            type: [String, Number],
        },
        archetype: {
            type: [Array, Object],
            default: () => archetype
        }
    },
    data: () => {
        return {
            form: {
                id: null
            },
            asides: {
                claves: {
                    divisiones: [],
                    grupos: [],
                    clases: [],
                    claves: [],

                    // FILTERED VERSIONS, NOT COMPUTED FOR PERFORMANCE
                    grupos_f: [],
                    clases_f: [],
                    claves_f: []
                },
                categorias: []
            },
        }
    },
    computed: {
        cArchetype() {
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if (!_.isArray(itemsRow)) {
                    updated.push(itemsRow);
                    return
                }
                let adding = []
                _.forEach(itemsRow, item => {
                    if (item.key == 'id_padre_fk') {
                        item.options = this.asides.categorias
                    }
                    else if (item.key == 'clave_clase_division') {
                        item.options = this.asides.claves.divisiones
                    }
                    else if (item.key == 'clave_clase_grupo') {
                        item.options = this.asides.claves.grupos_f
                    }
                    else if (item.key == 'clave_clase_clase') {
                        item.options = this.asides.claves.clases_f
                    }
                    else if (item.key == 'clave_clase_pk') {
                        item.options = this.asides.claves.claves_f
                    }
                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        captionsExceptBy,
        getHandler() {
            return automodalHandler(this.conceptId)
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (!!asides) {
                this.asides.claves.divisiones   = asides.claves.divisiones
                this.asides.claves.grupos       = asides.claves.grupos
                this.asides.claves.clases       = asides.claves.clases
                this.asides.claves.claves       = asides.claves.claves
                this.asides.categorias          = asides.categorias
            }
        },
        reloadClaves() {
            let clave = _.find(this.asides.claves.claves, { value: this.form.clave_clase_pk }),
                clase, grupo, division;
            if (!!clave) {
                clase = _.find(this.asides.claves.clases, { value: clave.clase_id })
                grupo = _.find(this.asides.claves.grupos, { value: clase.grupo_id })
                // division = _.find(this.asides.claves.divisiones, {value: grupo.division_id})
                this.form.clave_clase_division = grupo.division_id
                this.form.clave_clase_grupo = clase.grupo_id
                this.form.clave_clase_clase = clase.value
                this.$refs.automodal.set(this.form)
            }
            console.log("clave", clave, clase, grupo, division)
        },
        checkClaves() {
            let cp = _.cloneDeep(this.form);
            (() => {
                let filtering = { division_id: cp.clave_clase_division + '' }
                this.asides.claves.grupos_f = _.filter(this.asides.claves.grupos, filtering)
                if (!this.asides.claves.grupos_f.length) {
                    cp.clave_clase_grupo = null
                }
            })();
            (() => {
                let filtering = { grupo_id: cp.clave_clase_grupo + '' }
                this.asides.claves.clases_f = _.filter(this.asides.claves.clases, filtering)
                if (!this.asides.claves.clases_f.length) {
                    cp.clave_clase_clase = null
                }
            })();
            (() => {
                let filtering = { clase_id: cp.clave_clase_clase + '' }
                this.asides.claves.claves_f = _.filter(this.asides.claves.claves, filtering)

                if (!this.asides.claves.claves_f.length) {
                    cp.clave_clase_pk = null
                }
            })();
            if (JSON.stringify(cp) != JSON.stringify(this.form)) {
                // alert('asf')
                this.$refs.automodal.set(cp)
            }
        }
    },
    watch: {
        'form.clave_clase_division'() {
            let cp = _.cloneDeep(this.form),
                filtering = { division_id: cp.clave_clase_division + '' };

            this.asides.claves.grupos_f = _.filter(this.asides.claves.grupos, filtering)

            if (!this.asides.claves.grupos_f.length && !!this.$ref && this.$ref.automodal.isShown()) {
                cp.clave_clase_grupo = null
                this.$refs.automodal.set(cp)
            }
        },
        'form.clave_clase_grupo'() {
            let cp = _.cloneDeep(this.form),
                filtering = { grupo_id: cp.clave_clase_grupo + '' };
            this.asides.claves.clases_f = _.filter(this.asides.claves.clases, filtering)
            if (!this.asides.claves.clases_f.length && !!this.$ref && this.$ref.automodal.isShown()) {
                cp.clave_clase_clase = null
                this.$refs.automodal.set(cp)
            }
        },
        'form.clave_clase_clase'() {
            let cp = _.cloneDeep(this.form),
                filtering = { clase_id: cp.clave_clase_clase + '' };
            this.asides.claves.claves_f = _.filter(this.asides.claves.claves, filtering)
            if (!this.asides.claves.claves_f.length && !!this.$ref && this.$ref.automodal.isShown()) {
                cp.clave_clase_pk = null
                this.$refs.automodal.set(cp)
            }
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form" ref="automodal" :form-archetype="cArchetype" @refresh="refresh()"
        :handler="getHandler()" :size="(form.id)?'xl':'md'" @defined="checkAsides()" :allow-aside="!!form.id_pk"
        :allow-delete="!!form.id_pk" :form-id="form.id">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="9">
            <b-tabs pill>
                <b-tab title="Presentaciones">
                    <PresentacionQuicktable tipo="2" :elemento-id="form.id_pk" :captions="captionsExceptBy(['titulo_extendido', 'categoria'])"/>
                </b-tab>
            </b-tabs>

        </b-col>
        <b-col slot="bottom" v-if="false">

        </b-col>
    </ui-edit-auto-modal>
</template>

<style scoped>.positionate {
    position: relative;
    bottom: 10px;
}</style>